import state from './moduleSurveyState.js'
import mutations from './moduleSurveyMutations.js'
import actions from './moduleSurveyAction.js'
import getters from './moduleSurveyGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
